var map = {
	"./arbitration.pdf": "8085",
	"./arbitrationTax.pdf": "3a20",
	"./charter_newest.pdf": "bf80",
	"./contractTemplate.pdf": "789d",
	"./gosreg.pdf": "359d",
	"./location.pdf": "1f94",
	"./newContractTemplate.pdf": "03e7",
	"./newRules.pdf": "1000",
	"./newServiceContract.pdf": "cb57",
	"./paritetOffer.pdf": "a4e7",
	"./personalDataAgreement.pdf": "f08b",
	"./personalDataProcessing.pdf": "585c",
	"./registryInclude.pdf": "b822",
	"./report.pdf": "bde6",
	"./rules.pdf": "88d6",
	"./scoring.pdf": "7909",
	"./serviceContract.pdf": "63e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9873";